import * as React from 'react';

import * as UI from 'core/ui';

import { Res } from 'core/api';
import { ValueButtonGrid } from 'pos/ui';

import UpdateTipsScreen from './UpdateInvoiceTipsScreen.Common';
import { Flex } from 'core/ui';

export default class Tablet extends UpdateTipsScreen {

	protected useKeypad(): boolean {
		return true;
	}

	protected getContent(): React.ReactNode {
		const { Form, DecimalBox } = UI.controlsFor<typeof this.state>();

		return <Flex.Vertical>
			<Flex.Item className='m-l m-t-sm m-r'>
				<Form ref={this.form} model={this.state}>
					<DecimalBox placeholder={Res.Web.UPDATE_INVOICE_TIPS_ADD_TIP_PLACEHOLDER()} ref={this.txtAmount} linkTo={x => x.currentAmount} precision={2} allowNegative={false} />
				</Form>
			</Flex.Item>
			<Flex.Item>
				<ValueButtonGrid rows={1} values={this.props.availableMethods} onValueSelected={this.add} />
			</Flex.Item>
			<Flex.Item size='*'>
				{this.createTipList()}
			</Flex.Item>
		</Flex.Vertical>;
	}
}